package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_service_domain_di_ExtraCategoryServiceUseCaseModule : Module get() = module {
	single() { _ -> com.essntl.features.service.domain.use_case.ExtraCategoryServiceUseCase(categoryRepository=get(),serviceRepository=get()) } 
}
public val com.essntl.features.service.domain.di.ExtraCategoryServiceUseCaseModule.module : org.koin.core.module.Module get() = com_essntl_features_service_domain_di_ExtraCategoryServiceUseCaseModule
